const industries = [
  { label: 'Kurumsal Veri Merkezi', href: '/infrastructure-modernization' },
  { label: 'Kamu / Yönetim', href: '/secure-research-computing' },
  { label: 'Yükseköğretim', href: 'https://www.verge.io/blog/vmwareexit/cut-education-infrastructure-costs/' },
  { label: 'CSP / MSP', href: 'https://www.verge.io/blog/msp/infrastructure-strategies-for-service-providers/' },
  { label: 'Uç Bilişim / ROBO', href: '/edge-robo' },
];

export default function IndustriesSection() {
  return (
    <section className="bg-white py-12 px-6 border-b border-gray-100">
      <div className="max-w-[1280px] mx-auto text-center">
        <h2 className="text-xl font-bold text-[#1a1a2e] mb-8">VergeOS'u Kendi Sektörünüzde Keşfedin</h2>
        <div className="flex flex-wrap gap-3 justify-center">
          {industries.map((ind) => (
            <a
              key={ind.label}
              href={ind.href}
              className="px-5 py-2.5 border border-gray-200 rounded-full text-sm font-medium text-[#374151] hover:border-[#e8600a] hover:text-[#e8600a] hover:bg-orange-50 transition-all cursor-pointer whitespace-nowrap"
            >
              {ind.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
